import { useQuery } from "@tanstack/react-query";

import { getSinglePos } from "../core/retailShop.core";
import useGetRetailShopId from "./useGetRetailShopId.hook";

export default function useRetailShop() {
  const retailShopId = useGetRetailShopId();

  const { data } = useQuery({
    enabled: !!retailShopId,
    queryFn: () => getSinglePos(retailShopId!),
    queryKey: ["retailShopId", retailShopId],
  });

  return data;
}
